import React, { FC, useEffect, useRef } from 'react';
import { Box, Typography } from '@altermaind/web/ui';

type Props = {
  text: { category: 'question' | 'answer'; text: string }[];
};

export const Chat: FC<Props> = ({ text }) => {
  const chatRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const chatbox = chatRef.current;
    if (chatbox) {
      chatbox.scrollTop = chatbox.scrollHeight;
    }
  }, [text]);

  return (
    <Box>
      <Box
        id='chatbox'
        ref={chatRef}
        border='1px solid'
        borderColor='grey/dark/background'
        borderRadius='l'
        height='400px'
        width='100%'
        position='relative'
        backgroundColor='black'
        zIndex='1'
        overflowY={text.length > 0 ? 'scroll' : 'hidden'}
      >
        <Box p='s'>
          {text.map(item => (
            <Box
              textAlign={item.category === 'question' ? 'left' : 'right'}
              key={item.text}
              p='xxs'
            >
              <Box
                justifyContent={item.category === 'question' ? 'flex-start' : 'flex-end'}
                display='flex'
                flexDirection='row'
                alignItems='center'
              >
                <Box
                  width='15px'
                  height='15px'
                  borderRadius='50%'
                  mr='xxs'
                  style={{
                    backgroundColor:
                      item.category === 'question'
                        ? 'rgba(157, 139, 255, 1)'
                        : 'rgba(255, 255, 255, 1)',
                  }}
                />
                {item.category === 'question' ? (
                  <Typography variant='p3/label'>Tu</Typography>
                ) : (
                  <Typography variant='p3/label'>Federica</Typography>
                )}
              </Box>
              <Typography variant='p2/light' mt='xxs'>
                {item.text}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
